import { ActionReducerMap } from '@ngrx/store';
import { State } from '@state';

import { actionReducer } from './action/action.reducer';
import { authReducer } from './auth/auth.reducer';
import { contractReducer } from './contract';
import { criminalRecordCheckReducer } from './criminal-record-check';
import { customerReducer } from './customer';
import { documentTypeReducer } from './document-type/document-type.reducer';
import { expenseReducer } from './expense';
import { incidentReducer } from './incident';
import { inspectionReducer } from './inspection';
import { inspectionImageTypeReducer } from './inspection-image-type';
import { payRollReducer } from './pay-roll';
import { paymentReducer } from './payment';
import { serviceProviderReducer } from './service-provider';
import { serviceRequestReducer } from './service-request';
import { tripReducer } from './trip';
import { userReducer } from './user/user.reducer';
import { vehicleReducer } from './vehicle';

export const reducers: ActionReducerMap<State> = {
  auth: authReducer,
  user: userReducer,
  documentType: documentTypeReducer,
  action: actionReducer,
  vehicle: vehicleReducer,
  trip: tripReducer,
  inspectionImageType: inspectionImageTypeReducer,
  inspection: inspectionReducer,
  incident: incidentReducer,
  expense: expenseReducer,
  contract: contractReducer,
  payment: paymentReducer,
  serviceProvider: serviceProviderReducer,
  payRoll: payRollReducer,
  criminalRecordCheck: criminalRecordCheckReducer,
  customer: customerReducer,
  serviceRequest: serviceRequestReducer,
};
